import React from 'react';
import Edit from '../purchaseSaleEdit/Edit.jsx';
import AtomLinksEdit from './AtomLinksEdit.jsx';
import TransportLinksEdit from './TransportLinksEdit.jsx';
import { connect } from 'react-redux';
import LinkExisting from './LinkExisting';
import { linkCanceled } from '../../../../store/links.store';
import { locationFallThroughClear } from '../../../../util/util';
import { validateRoleConfig } from '../../../auth/RoleConfigFilter.jsx';
import { handleFormChanged } from '@/store/allaround.store';

class EditAndLinkClass extends React.Component {
  constructor(props) {
    super(props);
    this.startAtomsLinking = this.startAtomsLinking.bind(this);
    this.stopAtomsLinking = this.stopAtomsLinking.bind(this);
    this.saveLinkingFromList = this.saveLinkingFromList.bind(this);
    this.state = {
      atomsLinking: false,
      linkingFromListDone: false,
    };
  }

  startAtomsLinking(multiNodalQuantity) {
    this.props.handleFormChanged();
    this.setState({ atomsLinking: true, multiNodalQuantity });
  }

  stopAtomsLinking() {
    this.props.handleFormChanged();
    locationFallThroughClear('DEAL_LINK');
    this.props.linkCanceled(this.props.productToLinkIdx);
    this.setState({ atomsLinking: false });
  }
  saveLinkingFromList() {
    this.props.handleFormChanged();
    this.setState({ linkingFromListDone: true });
  }

  render() {
    const editStyle = (this.state.atomsLinking || this.props.linkToTransport
    || this.props.linkToExistingLink)
      ? { display: 'none' }
      : {};
    const disabled = !validateRoleConfig(['myDeals#2', 'allDeals#2']);
    return (
      <div>
        <div style={editStyle}>
          <Edit
            {...this.props}
            atomLinking={this.state.atomsLinking}
            key={this.props.params.dealId}
            type={this.props.dealFrom}
            startAtomsLinking={this.startAtomsLinking}
            stopAtomsLinking={this.stopAtomsLinking}
            linkingFromListDone={this.state.linkingFromListDone}
            readonly={disabled}
          />
        </div>
        <div>
          {this.props.linkToTransport ?
            <TransportLinksEdit
              dealFrom={this.props.dealFrom}
              dealTo={this.props.dealTo}
              multiNodalQuantity={this.state.multiNodalQuantity || this.props.multiNodalQuantity}
              saveLinkingFromList={this.saveLinkingFromList}
            />
            : ''
          }
          {this.props.linkToExistingLink ?
            <LinkExisting
              dealFrom={this.props.dealFrom}
              dealTo={this.props.dealTo}
            />
            : ''
          }
          {this.state.atomsLinking && !this.props.linkToTransport ?
            <AtomLinksEdit
              dealFrom={this.props.dealFrom}
              dealTo={this.props.dealTo}
              multiNodalQuantity={this.state.multiNodalQuantity}
              stopAtomsLinking={this.stopAtomsLinking}
            />
            : ''}
        </div>
      </div>
    );
  }
}

EditAndLinkClass.propTypes = {
  dealFrom: React.PropTypes.string,
  dealTo: React.PropTypes.string,
  linkToTransport: React.PropTypes.bool,
  linkToExistingLink: React.PropTypes.bool,
  params: React.PropTypes.object,
  linkCanceled: React.PropTypes.func,
  productToLinkIdx: React.PropTypes.number,
  multiNodalQuantity: React.PropTypes.number,
  handleFormChanged: React.PropTypes.func,
};

const EditAndLink = connect((state) => ({
  linkToTransport: state.getIn(['links', 'data', 'linkToTransport'], false),
  linkToExistingLink: state.getIn(['links', 'data', 'linkToExistingLink'], false),
  multiNodalQuantity: state.getIn(['links', 'data', 'multiNodalQuantity'], false),
  productToLinkIdx: state.getIn(['links', 'data', 'productToLinkIdx']),
}), (dispatch) => ({
  linkCanceled(productIdx) {
    linkCanceled(dispatch, productIdx);
  },
  handleFormChanged: () => handleFormChanged(dispatch),
}),
)(EditAndLinkClass);

export const PurchaseEditAndLink = (props) =>
  (<EditAndLink {...props} dealFrom="purchase" dealTo="sale" />);

export const SaleEditAndLink = (props) =>
  (<EditAndLink {...props} dealFrom="sale" dealTo="purchase" />);
